import { IConsumptions } from "@edp-components/edp-card-widgets/edp-widget-conta-certa/edp-conta-certa.model";
import { SmartNowConsumptionEvolution, SmartNowConsumptionEvolutionValues } from "@edp-models/smart-now.model";
import { ConsumptionHistory, IConsumptionsChartData, IConsumptionsPeriod } from "@edp-models/consumptions.model";

export interface IConsumptionState {
    consumptions: {
        data: IConsumptions;
        lastAPIError: Error;
        chartData?: IConsumptionsChartData[];
        period?: IConsumptionsPeriod;
        consumptionHistory?: ConsumptionHistory;
        mobieConsumptionHistory?: ConsumptionHistory;
    };
    consumptionEvolution: SmartNowConsumptionEvolution;
    consumptionSelected: SmartNowConsumptionEvolutionValues[];
    activeTab: string;
    mobieCardList: string[];
    mobieConsumptions: SmartNowConsumptionEvolution;
}

export const initialConsumptionState: IConsumptionState = {
    consumptions: {
        data: null,
        lastAPIError: null,
        chartData: null,
        period: null,
        consumptionHistory: null,
        mobieConsumptionHistory: null,
    },
    consumptionEvolution: null,
    consumptionSelected: null,
    mobieCardList: null,
    activeTab: null,
    mobieConsumptions: null,
};
